export class ProductConfigurationModel {
    name: string;
    value: string;
    show = true;
    label: string;
    isDropDown = false;
}
